package com.gsb.vyapar.bhagya.datasource.mqtt

sealed class MQTTEvents {
    object OnConnected : MQTTEvents()
    data class OnDisconnected(val error: String) : MQTTEvents()
    data class OnMessageReceived(val topic: String, val message: String) : MQTTEvents()
}
